import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { WithTitle } from '../../common/props/layoutProps';
import { LoadingProps } from '../../common/props/loadingProps';
import { localizations } from '../../localization/localization';

const styles = (theme: Theme) => ({
    title: {
        padding: theme.spacing(2)
    }
});

type BlockProps = WithTitle & WithStyles<"title"> & LoadingProps;

const StatisticsBlockSmall: React.SFC<BlockProps> = (props) => {

    const { classes, title } = props;
    const isLoading = props.isLoading || false;

    return (
        <Grid item xs={6} md={3}>
            <Paper>
                <Grid container direction="column">
                    <Grid item xs={12}>
                        <Typography className={classes.title} color="primary" variant="subtitle1">{title}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        {isLoading ? <div>{localizations.actions.loading}</div> :
                            <React.Fragment>
                                {props.children}
                            </React.Fragment>
                        }
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    );
}

export default withStyles(styles)(StatisticsBlockSmall);


// WEBPACK FOOTER //
// ./src/statistics/components/StatisticsBlockSmall.tsx